import { useMemo } from 'react';
import { useStore } from '@/app/providers/store';

/**
 * 用户地区信息判断Hook
 * 登录用户基于标签判断，未登录用户调用IP接口判断
 */
export const useUserRegion = () => {
  const { userInfo, countryLevel, isUserInfoInitialized } = useStore((state) => ({
    userInfo: state.userInfo,
    countryLevel: state.countryLevel,
    isUserInfoInitialized: state.isUserInfoInitialized,
  }));

  // 检查是否已登录（需要等待初始化完成）
  const isLoggedIn = isUserInfoInitialized && !!userInfo;

  // 缓存计算结果
  const regionInfo = useMemo(() => {
    // 如果还未初始化完成，返回默认值
    if (!isUserInfoInitialized) {
      return { isT1User: false };
    }

    // 登录用户：使用标签判断
    if (isLoggedIn) {
      return { isT1User: userInfo?.tags?.includes('T1') || false };
    }

    // 未登录用户：使用 countryLevel 判断
    return { isT1User: countryLevel === 't1' };
  }, [isUserInfoInitialized, isLoggedIn, userInfo?.tags, countryLevel]);

  return {
    ...regionInfo,
  };
};
